import * as React from "react"
import { List } from "immutable"
import{ Link } from "./library/link"
import { slugify } from "../../custom_utils/helpers"
import { VideoBlock } from "./video_block"

export type TeasersProps = {
  items: List<TeaserProps>
}

export type TeaserProps = {
  extraClasses?: string
  linkUrl?: string
} & TeaserContentProps

export type TeaserInnerProps = {
  linkUrl?: string
  linkText?: string
  teaserContent: JSX.Element
  title: string
}

export type TeaserContentProps = {
  headingLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  title: string,
  isTip?: boolean,
  label?: string | JSX.Element,
  imageAlt?: string,
  imageUrl?: string,
  videoUrl?: string,
  linkText?: string,
  intro?: string,
  footer?: JSX.Element | string
}

export const Teasers = (p: TeasersProps & { row_count: number }): JSX.Element => 
  <ul className="teasers row">
    {p.items.map((i, k) => <Teaser key={'teaser-'+k} {...i} row_count={p.row_count} />)}
  </ul>

export const Teaser = (p: TeaserProps & { row_count: number }): JSX.Element =>
  <li 
    className={`teaser ${p.imageUrl ? 'teaser--image' : ''} ${p.extraClasses ? p.extraClasses : ''} ${p.row_count == 4 ? "col-xs-12 col-sm-6 col-md-4 col-ld-3" : "col-xs-12 col-sm-6 col-md-4"}`}
    // IF THE BLOCK IS SHOWN IN FOUR COLUMN THE FOLLOWING CLASSES SHOULD BE USED "col-xs-12 col-sm-6 col-md-4 col-ld-3"
    // OR "col-xs-12 col-sm-6 col-md-3"
  >
    {TeaserInner({ linkUrl: p.linkUrl, teaserContent: TeaserContent(p), title: p.title })}
  </li>

export const TeaserInner = (p: TeaserInnerProps) =>
  // p.linkUrl.substring(0, 4) == "http" ? (
  //   <a
  //     href={p.linkUrl}
  //     target="_blank"
  //     rel="noopener"
  //     className="teaser__link"
  //     aria-labelledby={`a11y-teaser-title-${slugify(p.title)}`}
  //   >
  //     {p.teaserContent}
  //   </a>
  // ) : (
      <Link
        url={p.linkUrl}
        className="teaser__link"
        aria-labelledby={`a11y-teaser-title-${slugify(p.title)}`}
      >
        {p.teaserContent}
      </Link>
  //   )

export const TeaserContent = (p: TeaserContentProps) => {
  const Heading = p.headingLevel;
  return (
    <article data-anchor={slugify(p.title)} className="teaser__inner">
      <header className="teaser__header">
        <Heading className="teaser__title title--m" id={`a11y-teaser-title-${slugify(p.title)}`}>
          <span dangerouslySetInnerHTML={{ __html: p.title }} />
        </Heading>
        {p.isTip && (
          <>
            <span className="teaser__tip">Tip</span>
            <span className="sr-text"> van de redactie</span>
          </>
        )}
      </header>
      {p.intro && <p className="teaser__intro" dangerouslySetInnerHTML={{ __html: p.intro }} />}
      {p.footer && (
        <footer className="teaser__footer">
          <span className="sr-text">Locatie: </span>
          {p.footer}
        </footer>
      )}
      {p.imageUrl && (
        <div className="teaser__visual">
          {p.label && <div className="teaser__label">{p.label}</div>}
          <img src={p.imageUrl} alt={p.imageAlt} className="teaser__image" />
        </div>
      )}
      {p.videoUrl && (
        <div>
          <figure className="block block--video block--video--no-margin">
            <iframe key="iframe" className="block__iframe" src={p.videoUrl} frameBorder="0" title={p.title} />
          </figure>
        </div>
      )}

      {p.linkText && (
      <div className="teaser__fauxlink">
        <svg className="teaser__fauxlink-icon" width="8px" height="14px" aria-hidden="true"><use xlinkHref="#icon--chevron-right"></use></svg>
        <span>{p.linkText}</span>
      </div>
      )}
    </article>
  )
}

export const SliderTeaserContent = (p: TeaserContentProps) => {
  const Title = p.headingLevel;
  return (
    <article data-anchor={slugify(p.title)} className="teaser__inner">
      <div className="teaser__text">
        <header className="teaser__header">
          <Title className="teaser__title title--m">
            {p.isTip && <span className="teaser__tip">TIP</span>}
            <span>{p.title}</span>
          </Title>
        </header>
  
        {p.intro && <p className="teaser__intro" dangerouslySetInnerHTML={{ __html: p.intro }} />}
        {p.footer && <footer className="teaser__footer">{p.footer}</footer>}
      </div>

      {p.imageUrl && (
        <div className="teaser__visual">
          {p.label && <div className="teaser__label">{p.label}</div>}
          <img src={p.imageUrl} alt={p.imageAlt} className="teaser__image" />
        </div>
      )}

      {p.videoUrl && (
        <div className="teaser__visual">
          {p.label && <div className="teaser__label">{p.label}</div>}
          <VideoBlock 
            autoplay={false}
            controls={true}
            info={true}
            videoName={p.title}
            videoUrl={p.videoUrl}
          />
      </div>
      )}
    </article>
  )
}

export const SliderTeaser = (p: TeaserProps): JSX.Element =>
  <div className="teaser teaser--image">
    {TeaserInner({ linkUrl: p.linkUrl, teaserContent: SliderTeaserContent(p), title: p.title })}
  </div>